
export const TERMS_VERSION = 1;
export const PRIVACY_POLICY_VERSION = 1;
